/**
 * Moves a server-supplied question (`/chat?frage=`) into the input — as a
 * value, never as HTML — and drops `frage` and `persona` from the address, so
 * a reload does not bring them back (ADR-0077 decision 7). Returns true when
 * it filled the field. Nothing is sent.
 */
export function applyPrefill(input, win = window) {
    const text = input.dataset.prefill;
    if (!text) return false;
    input.value = text;
    delete input.dataset.prefill;
    const url = new URL(win.location.href);
    url.searchParams.delete('frage');
    url.searchParams.delete('persona');
    win.history.replaceState(win.history.state, '', url.pathname + url.search + url.hash);
    return true;
}

/**
 * The persona name the server put beside a prefilled question
 * (`/chat?persona=`), removed from the element; '' when there is none.
 */
export function takePrefillPersona(input) {
    const name = input.dataset.prefillPersona || '';
    delete input.dataset.prefillPersona;
    return name;
}

/**
 * The standard persona of that exact name, or null. Only standard personas:
 * a link must not pick an account's own persona that happens to share it.
 */
export function pickStandardPrompt(prompts, name) {
    if (!name) return null;
    return prompts.find(p => p.is_standard && p.name === name) || null;
}

/**
 * The standard persona with that id, or null. Only standard personas: a
 * stored default never selects an own persona (ADR-0082 decision 3).
 */
export function pickStandardById(prompts, id) {
    if (!id) return null;
    return prompts.find(p => p.is_standard && String(p._id) === id) || null;
}

/**
 * The persona a chat starts with (ADR-0082 decision 2): the tile's, the
 * account's default, the site default, else the first standard persona.
 * Standard personas only at every step; null for an empty list.
 */
export function pickStartingPrompt(prompts, { prefillName, defaultId, defaultName }) {
    return pickStandardPrompt(prompts, prefillName)
        || pickStandardById(prompts, defaultId)
        || pickStandardPrompt(prompts, defaultName)
        || prompts.find(p => p.is_standard)
        || null;
}
